var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"pinchReference",staticClass:"pinch-zoomable"},[_c('square-image',{attrs:{"src":_vm.src,"srcset":_vm.srcset}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }